import { LoaderCircle } from 'lucide-react';
import type { SVGProps } from 'react';
import { cn } from '../lib/utils.js';

/** Loading indicator — lucide glyph on a CSS spin. Inherits currentColor. */
export function Spinner({ className, ...rest }: SVGProps<SVGSVGElement>) {
  return (
    <LoaderCircle aria-hidden="true" className={cn('size-5 animate-spin', className)} {...rest} />
  );
}
